const MARKETPLACE_OPERATOR_ROLES = new Set([
  "admin",
  "host",
  "owner",
  "manager",
  "reception",
  "receptionist",
]);

export const MARKETPLACE_STAFF_ONLY_ROLES = new Set([
  "apprentice",
  "solo_technician",
  "technician",
]);

const MARKETPLACE_ACCOUNT_ROLES = new Set([
  ...MARKETPLACE_OPERATOR_ROLES,
  "independent_professional",
  "renter",
]);

export function isMarketplaceOperatorRole(role = "") {
  return MARKETPLACE_OPERATOR_ROLES.has(String(role || "").toLowerCase());
}

export function canAccessMarketplaceOperatorShell({ role = "", user = null } = {}) {
  const normalizedRole = String(role || user?.role || "").toLowerCase();
  if (normalizedRole === "independent_professional") {
    return Boolean(user?.is_super_admin);
  }
  return (
    Boolean(user?.is_super_admin) ||
    isMarketplaceOperatorRole(normalizedRole) ||
    Boolean(user?.has_owner_access)
  );
}

export function canOpenMyBoothShare({ role = "", user = null } = {}) {
  const normalizedRole = String(role || user?.role || "").toLowerCase();
  if (Boolean(user?.is_super_admin)) return true;
  if (MARKETPLACE_STAFF_ONLY_ROLES.has(normalizedRole)) return false;
  if (canAccessMarketplaceOperatorShell({ role: normalizedRole, user })) return true;
  return MARKETPLACE_ACCOUNT_ROLES.has(normalizedRole);
}

export function canAccessMarketplaceAccountShell(user = null) {
  return canOpenMyBoothShare({ role: user?.role, user });
}

export function isIndependentMarketplaceOperator(user = null) {
  return (
    String(
      user?.default_workspace_operator_mode ||
        user?.renter_profile?.default_workspace_operator_mode ||
        ""
    )
      .trim()
      .toLowerCase() === "independent_owner"
  );
}

export function isStaffMarketplaceUser(user = null) {
  const mode = String(
    user?.default_workspace_operator_mode ||
      user?.renter_profile?.default_workspace_operator_mode ||
      ""
  )
    .trim()
    .toLowerCase();
  return (
    mode === "staff_technician" &&
    Boolean(user?.has_technician_access) &&
    !Boolean(user?.has_owner_access)
  );
}

export function canAccessMarketplaceRenterHistory(user = null) {
  if (!user) return false;
  if (Boolean(user?.is_super_admin)) return true;
  if (Boolean(user?.has_owner_access)) return true;
  return !isStaffMarketplaceUser(user);
}
